import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class NotificationsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllDefaultNotificationSettings(router){
    const url = `/api/notifications/default`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getDefaultNotificationSettingById(id, router) {
    const url = `/api/notifications/default/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getDefaultNotificationSettingByFlightSchoolId(id, router) {
    const url = `/api/notifications/default/school/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createDefaultNotificationSetting(params, router) {
    const url = `/api/notifications/default`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateDefaultNotificationSetting(id, params, router) {
    const url = `/api/notifications/default/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteDefaultNotificationSetting(id, router) {
    const url = `/api/notifications/default/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

}
export default NotificationsAPIService;
